import React from 'react';
import {Row, Col, Input } from 'antd'
import { useTranslation } from 'react-i18next';

const CasaMatriz = ({casaMatriz={}, actual}) => {
    const { t } = useTranslation();
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={6}>
                    {t("messages.aml.name")}
                    <Input readOnly value={casaMatriz.nombreMatriz} className={actual && casaMatriz.nombreMatriz !== actual.nombreMatriz && "difference"}/>
                </Col>
                <Col span={6}>
                    {t("messages.aml.country")}
                    <Input readOnly value={casaMatriz.paisMatriz} className={actual && casaMatriz.paisMatriz !== actual.paisMatriz && "difference"}/>
                </Col>
                <Col span={6}>
                    {t("messages.aml.city")}
                    <Input readOnly value={casaMatriz.ciudadMatriz} className={actual && casaMatriz.ciudadMatriz !== actual.ciudadMatriz && "difference"}/>
                </Col>
                <Col span={6}>
                    {t("messages.aml.address")}
                    <Input readOnly value={casaMatriz.direccionMatriz} className={actual && casaMatriz.direccionMatriz !== actual.direccionMatriz && "difference"}/>
                </Col>
            </Row>
        </div>
    );
};

export default CasaMatriz;